import { call, put, takeEvery } from 'redux-saga/effects'
import { api } from '../services/api'
import { logRavenError, setUserContext } from '../services/raven'
import { publishTracking } from '../services/tracking'
import {
  REGISTRATION_PENDING,
  REGISTRATION_SUCCESS,
  REGISTRATION_FAIL,
  CHANGE_AUTH_STATE,
} from '../actions/index'

import sendPostMessage from '../services/post-communication'
import constants from '../constants/index'

function* startRegistration(action) {
  const { payload } = action
  let user = ''

  try {
    user = yield call(api.register, payload)
    yield put({ type: REGISTRATION_SUCCESS, payload: user })
    yield put({ type: CHANGE_AUTH_STATE, payload: user.data })

    if (!payload.isRedirectFlow) {
      yield call(sendPostMessage, { ...user.data, ...constants.USER_ACTIONS.login })

      publishTracking({
        clientId: user.data.UID,
        userAction: 'sign up',
        origin: 'time out',
        event: 'event45',
      })
    }

    yield call(setUserContext, { email: user.data.email })
  } catch (e) {
    yield put({ type: REGISTRATION_FAIL, payload: e.response })
    // scrub sensitive data from error before sending it to sentry
    delete e.response.config.data
    yield call(logRavenError, 'Registration fail', e, e.response)

    if (!payload.isRedirectFlow) {
      publishTracking({
        userAction: 'join error',
        origin: 'time out',
        event: 'event146',
      })
    }
  }
}

function* registration() {
  yield takeEvery(REGISTRATION_PENDING, startRegistration)
}

export default registration



// WEBPACK FOOTER //
// ./src/sagas/register.js